import { Label, LoadingWrapper, Tooltip } from "client/CommonComponents";

const PurchaseOrder = (props?: any) => {
    const {
        assetItemStatusTemp,
        isLoading
    }: any = props;

    return (
        <div className="purchaseorder-bulkorderfleet p-3">
             <LoadingWrapper isLoading={isLoading} data-attribute="PurchaseOrder_Default_LoadingWrapper"> 
            <div>
                <Label data-attribute="PurchaseOrder_Default_Label">PO #</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseOrder?.ponumber || '-'} data-attribute="PurchaseOrder_Default_Tooltip">
                    <div className="content">{assetItemStatusTemp?.purchaseOrder?.ponumber || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseOrder_Default_Label_2">Make</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseOrder?.make || '-'} data-attribute="PurchaseOrder_Default_Tooltip_2">
                    <div className="content">{assetItemStatusTemp?.purchaseOrder?.make || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseOrder_Default_Label_3">Model</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseOrder?.model || '-'} data-attribute="PurchaseOrder_Default_Tooltip_3">
                    <div className="content">{assetItemStatusTemp?.purchaseOrder?.model || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseOrder_Default_Label_4">GL Account #</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseOrder?.glaccountNumber || '-'} data-attribute="PurchaseOrder_Default_Tooltip_4">
                    <div className="content">{assetItemStatusTemp?.purchaseOrder?.glaccountNumber || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseOrder_Default_Label_5">PO Description 1 #</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseOrder?.podescription1 || '-'} data-attribute="PurchaseOrder_Default_Tooltip_5">
                    <div className="content">{assetItemStatusTemp?.purchaseOrder?.podescription1 || '-'}</div>
                </Tooltip>
            </div>
            <div>
                <Label data-attribute="PurchaseOrder_Default_Label_6">PO Description 2 #</Label>
                <Tooltip content={assetItemStatusTemp?.purchaseOrder?.podescription2 || '-'} data-attribute="PurchaseOrder_Default_Tooltip_6">
                    <div className="content">{assetItemStatusTemp?.purchaseOrder?.podescription2 || '-'}</div>
                </Tooltip>
            </div>
            </LoadingWrapper> 
        </div>
    )
}

export default PurchaseOrder